<template>
  <header class="bg-black relative">
    <ResponsiveImage
      :media="content.image"
      class="h-[120dvh] w-full object-cover"
      v-reveal="{ class: 'v-reveal-image' }"
    />
    <div
      style="--banner-offset: calc(20dvh + 216px)"
      class="h-pad pb-5 -translate-y-(--banner-offset) -mb-(--banner-offset) lg:p-0 lg:absolute lg:bottom-[20dvh] lg:left-0 xl:left-1/2 xl:-translate-x-1/2 transition-[left_translateX]"
    >
      <div
        v-reveal
        class="bg-burgundy text-dustrose p-2.5 text-center max-w-100 lg:max-w-none lg:w-200 mx-auto relative"
      >
        <div
          class="border border-pink p-5 lg:px-10 lg:py-13.5 relative z-20 bg-burgundy transition-padding"
        >
          <h1 class="font-subtitle uppercase text-5xl tracking-wider lg:text-7xl">
            {{ content.title }}
          </h1>
          <div
            class="flex justify-between mt-2.5 w-full lg:absolute lg:bottom-13.75 lg:left-0 lg:px-10 lg:-translate-y-4"
          >
            <p class="font-title uppercase text-pink text-sm w-20">
              {{ content.left_text }}
            </p>
            <p class="font-title uppercase text-pink text-sm w-20">
              {{ content.right_text }}
            </p>
          </div>
        </div>
        <div class="hidden lg:block w-30 h-30 bg-burgundy z-10 absolute top-0 right-0"></div>
        <SiteAddress
          class="w-full bg-burgundy border-pink [&_.social]:hover:text-dustrose lg:[&_.social]:hover:text-burgundy border-b border-l border-r lg:border-t [&_.font-title]:text-pink lg:absolute lg:top-18 lg:right-18 lg:translate-x-full lg:-translate-y-full lg:bg-dustrose lg:text-burgundy lg:[&_.font-title]:text-burgundy lg:max-w-70"
        />
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import type { PropType } from 'vue'

import SiteAddress from '@/components/blocks/SiteAddress.vue'
import ResponsiveImage from '@/components/helpers/ResponsiveImage.vue'

export default {
  name: 'HomeHeader',
  components: { ResponsiveImage, SiteAddress },
  props: {
    content: {
      type: Object as PropType<HomeHeader>,
      required: true,
    },
  },
}
</script>
